import React, { Component } from "react";

class HolidayActivityList extends Component {
  render() {
    return <div></div>;
  }
}

export default HolidayActivityList;
